import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as o}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const m=t("horizontal_rule",o`
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.75 13.25C3.39583 13.25 3.09896 13.1302 2.85937 12.8906C2.61979 12.651 2.5 12.3542 2.5 12C2.5 11.6458 2.61979 11.349 2.85937 11.1094C3.09896 10.8698 3.39583 10.75 3.75 10.75H21.25C21.6042 10.75 21.901 10.8698 22.1406 11.1094C22.3802 11.349 22.5 11.6458 22.5 12C22.5 12.3542 22.3802 12.651 22.1406 12.8906C21.901 13.1302 21.6042 13.25 21.25 13.25H3.75Z"
                fill="#FCFCFC" />
        </svg>
    `);export{m as HorizontalRule};
